import styled from '@emotion/styled';
import { css } from '@emotion/react';
import Wrapper from 'shared/components/Content/Wrapper';
import { Text } from '@blueprint/text';
import { Heading1, Heading3 } from '@blueprint/heading';
import { Banner } from '@blueprint/ui';
import { Button, ButtonLink } from '@blueprint/button';
import { Checkbox } from '@blueprint/checkbox';

export const Layout = styled(Wrapper)(
    css`
        display: block;
    `
).withComponent('main');

export const SavedListingsHeader = styled(Heading1)(
    ({ theme: { fontSizes, mq, spacing } }) => css`
        margin-top: ${spacing['32px']};
        margin-bottom: ${spacing['8px']};

        ${mq.medium} {
            font-size: ${fontSizes[4]};
        }
    `
);

export const CenteredBox = styled('div')(
    ({ theme: { mq, spacing } }) => css`
        display: flex;
        align-items: center;
        flex-direction: column;
        margin-bottom: ${spacing['24px']};

        img {
            display: block;
            margin-top: ${spacing['24px']};
            max-width: 50.5rem;
            width: calc(100% + 2rem);

            ${mq.medium} {
                margin-top: ${spacing['32px']};
                width: 100%;
            }
        }

        ${ButtonLink} {
            margin-top: ${spacing['48px']};
            max-width: 20rem;
        }
    `
);

export const InstructionText = styled(Text)(
    ({ theme: { fontSizes, spacing } }) => css`
        font-size: ${fontSizes[9]};
        margin-top: ${spacing['8px']};

        svg {
            display: inline-block;
            height: 1.13em;
            width: 1.13em;
            transform: translateY(-0.07em);
            vertical-align: middle;
        }
    `
);

export const FiltersContainer = styled('div')(
    ({ theme: { spacing } }) => css`
        padding: ${spacing['8px']} 0;
        margin-bottom: -1rem;

        ${Checkbox} {
            display: inline-block;

            label {
                user-select: none;
            }
        }
    `
);

export const PropertiesContainer = styled('div')(
    ({ theme: { spacing } }) => css`
        margin-bottom: ${spacing['24px']};
    `
);

export const NumberOfProperties = styled(Heading3)(
    ({ theme: { colors, spacing } }) => css`
        color: ${colors['neutral-5']};
        margin-top: 0;
        margin-bottom: ${spacing['32px']};
        font-weight: normal;
    `
);

export const StyledBanner = styled(Banner)(
    ({ theme: { spacing } }) => css`
        position: absolute;
        bottom: ${spacing['8px']};

        ${Button} {
            &:hover:not(:active) {
                box-shadow: none;
                transform: none;
            }
            cursor: pointer;
            position: absolute;
            top: ${spacing['4px']};
            right: ${spacing['4px']};
        }
    `
);

export const Loader = styled('img')(
    ({ theme: { mq, spacing } }) => css`
        display: block;
        left: 0;
        margin: ${spacing['48px']} auto ${spacing['16px']};
        position: relative;
        right: 0;

        ${mq.medium} {
            margin: ${spacing['24px']} auto 0;
        }
    `
);

export const PropertyNotesNotice = styled(Text)(
    ({ theme: { mq, spacing } }) => css`
        display: none;

        ${mq.medium} {
            display: block;
            margin-top: ${spacing['48px']};
            margin-bottom: ${spacing['16px']};
        }
    `
);
